import React from 'react';
import { Skeleton } from './ui/skeleton';

export const StatsGridSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-testid="stats-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white dark:bg-neutral-800 border-2 border-black dark:border-neutral-700 rounded-xl p-5 shadow-[4px_4px_0px_#000]">
        <Skeleton className="h-8 w-8 mb-3 rounded" />
        <Skeleton className="h-3 w-20 mb-2" />
        <Skeleton className="h-8 w-12" />
      </div>
    ))}
  </div>
);

export const JobListSkeleton = ({ count = 4 }) => (
  <div className="space-y-4" data-testid="job-list-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6">
        <div className="flex items-start justify-between mb-3">
          <Skeleton className="h-5 w-2/3" />
          <Skeleton className="h-6 w-20 rounded-full" />
        </div>
        <Skeleton className="h-3 w-full mb-2" />
        <Skeleton className="h-3 w-5/6 mb-4" />
        <div className="flex gap-3">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
    ))}
  </div>
);

export const DashboardSkeleton = () => (
  <div className="min-h-screen bg-[#E8E9EB] dark:bg-[#121212]" data-testid="dashboard-skeleton">
    <div className="bg-[#0F172A] border-b-4 border-black py-6">
      <div className="max-w-7xl mx-auto px-4">
        <Skeleton className="h-6 w-48 mb-2 bg-neutral-700" />
        <Skeleton className="h-3 w-64 bg-neutral-700" />
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 py-6">
      <StatsGridSkeleton />
      <div className="grid md:grid-cols-2 gap-6">
        <Skeleton className="h-56 rounded-xl" />
        <Skeleton className="h-56 rounded-xl" />
      </div>
    </div>
  </div>
);
